var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAdditionalService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 5V9.5L10.025 11.675L10.625 10.775L7.625 8.975V5H6.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.44 8C12.4775 8.2475 12.5 8.495 12.5 8.75C12.5 11.675 10.175 14 7.25 14C4.325 14 2 11.675 2 8.75C2 5.825 4.325 3.5 7.25 3.5C7.775 3.5 8.2775 3.575 8.75 3.7175V2.1725C8.27 2.06 7.7675 2 7.25 2C3.5 2 0.5 5 0.5 8.75C0.5 12.5 3.5 15.5 7.25 15.5C11 15.5 14 12.5 14 8.75C14 8.495 13.985 8.2475 13.955 8H12.44Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 2.75V0.5H12.5V2.75H10.25V4.25H12.5V6.5H14V4.25H16.25V2.75H14Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdditionalService);
export default __webpack_public_path__ + "static/media/icon_additional_service.87372737a3e4a7c1a3f1351d458aa1ae.svg";
export { ForwardRef as ReactComponent };